export default function CloudsBackground() {
  return (
    <div className="wv-sky" aria-hidden="true">
      <div className="wv-cloud wv-cloud-1" />
      <div className="wv-cloud wv-cloud-2" />
      <div className="wv-cloud wv-cloud-3" />
      <div className="wv-cloud wv-cloud-4" />
      <div className="wv-cloud wv-cloud-5" />
    </div>
  );
}
